import React, { FC, useState } from "react";
import classes from "./Login.module.scss";
import logo from "../../assets/logo.png";
import google from "../../assets/google.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loadingState, loadingText } from "../../states/LoadingState";
import { ErrorModal } from "../../components/uikit/atoms/ErrorModal";
import { useLogin } from "../../hooks/useLogin";
import { Header } from "../header/Header";
import { Footer } from "../footer/Footer";
import SwitchMode from "../uikit/atoms/SwitchMode";
import {
  backgroundColorLoginDesc,
  foreColorLoginDesc,
} from "../../commons/colors";
import { userState } from "../../states/userState";
import { productNoState } from "../../states/poductNoState";

const Login = () => {
  const navigation = useNavigate();
  const recoilProductNo = useRecoilValue(productNoState);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("ログインエラー");
  const [message, setMessage] = useState("Google認証に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const { loginWithGoogle, error } = useLogin();
  const user = useRecoilValue(userState);
  const onClickLogin = async () => {
    //ローディング表示
    //画面
    setLoadingAnimation(true);
    setLoadingText("認証中...");
    //ボタン
    setLoading(true);
    try {
      const isSuccess = await loginWithGoogle();
      if (isSuccess !== 0) {
        setMessage("Google認証に失敗しました");
        setIsShowErrorDialog(true);
      } else {
        let productNo =
          recoilProductNo.productNo + "-" + recoilProductNo.productBno;
        if (productNo.endsWith("-")) productNo = productNo.slice(0, -1);
        navigation(productNo.length > 1 ? `/?productNo=${productNo}` : "/");
      }
    } catch (error) {
      //モーダル表示
      setMessage("Google認証に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoading(false);
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  const ImageIcon = () => {
    return (
      <img
        src={google}
        alt="Login"
        style={{ width: 32, height: 24, paddingRight: 10 }}
      />
    );
  };
  return (
    <>
      <Header props="ログインページ" />
      <div
        className={classes.login}
        style={backgroundColorLoginDesc(user?.mode ?? "dark")}
      >
        <div className={classes.loginWrapper}>
          <div className={classes.loginLeft}>
            <h3 className={classes.loginTitle}>AquaDRAFTS</h3>
            <span
              className={classes.loginDesc}
              style={foreColorLoginDesc(user?.mode ?? "dark")}
            >
              設計図面閲覧
            </span>
          </div>
          <div className={classes.loginRight}>
            <div
              className={
                user?.mode === "lite" ? classes.loginBoxLight : classes.loginBox
              }
            >
              <div className={classes.switch}>
                <SwitchMode />
              </div>
              <div className={classes.loginLogo}>
                <img src={logo} alt="" />
              </div>
              <LoadingButton
                onClick={onClickLogin}
                loadingPosition="start"
                startIcon={<ImageIcon />}
                loading={loading}
                variant="contained"
              >
                ログイン
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </>
  );
};

export default Login;
